"use client";

import { c as _c } from "react/compiler-runtime";
import { GDPRInfoPanel } from "@/app/[lng]/_components/cookie-modal/cookie-info";
import { GDPRCookiesSettings } from "@/app/[lng]/_components/cookie-modal/cookie-settings";
import { useRouter } from "next/navigation";
import { AnalyticsActions, AnalyticsCategories, AnalyticsEventType, AnalyticsLabels } from "@/constants/analytics";
import { sendGTMEvent } from "@/components/Tracking/TagManagerWrapper";
import { Modal } from "@/components/Util/Modal";
import { useTranslation } from "@/app/i18n/client";
import { useEffect, useState } from "react";
import { useAnalyticsState } from "@/utils/hooks/use-analytics-state";
export function GDPRCookiesModal() {
  const $ = _c(16);
  const [showCookieModal, setShowCookieModal] = useState(false);
  const {
    analyticsCookie
  } = useAnalyticsState();
  const isFirstVisit = analyticsCookie === undefined;
  const {
    t
  } = useTranslation();
  let t0;
  let t1;
  if ($[0] !== isFirstVisit) {
    t0 = () => {
      if (isFirstVisit) {
        setShowCookieModal(true);
      }
    };
    t1 = [isFirstVisit];
    $[0] = isFirstVisit;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleModalClose(newState) {
      setShowCookieModal(newState);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleModalClose = t2;
  let t3;
  if ($[4] !== t) {
    t3 = t("GDPRSETTINGS.TITLE");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("MAIN.COOKIESETTINGS.TEXT");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <button type="button" className="inline-block p-0 [font-size:inherit]">{t4}</button>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <GDPRCookiesModalContent />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isFirstVisit || $[12] !== showCookieModal || $[13] !== t3 || $[14] !== t5) {
    t7 = <Modal header={t3} changedOpen={handleModalClose} open={showCookieModal} preventDismiss={true} preventCloseAutoFocus={isFirstVisit} trigger={t5}>{t6}</Modal>;
    $[11] = isFirstVisit;
    $[12] = showCookieModal;
    $[13] = t3;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function GDPRCookiesModalContent() {
  const $ = _c(15);
  const [showSettingsPanel, setShowSettingsPanel] = useState(false);
  const {
    analyticsCookie,
    setAnalyticsCookie
  } = useAnalyticsState();
  const router = useRouter();
  let t0;
  if ($[0] !== router || $[1] !== setAnalyticsCookie) {
    t0 = function rejectAll() {
      setTimeout(() => {
        sendGTMEvent(AnalyticsEventType.Event, AnalyticsCategories.gdprCookiesInfo, AnalyticsLabels.button, AnalyticsActions.declineAllGdprCookiesClick);
        setAnalyticsCookie({
          isStatisticsOn: false,
          isMarketingOn: false,
          isSentryOn: false
        });
        document.cookie = "";
        router.refresh();
      }, 1000);
    };
    $[0] = router;
    $[1] = setAnalyticsCookie;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const rejectAll = t0;
  let t1;
  if ($[3] !== setAnalyticsCookie) {
    t1 = function acceptAll() {
      setTimeout(() => {
        setAnalyticsCookie({
          isStatisticsOn: true,
          isMarketingOn: true,
          isSentryOn: true
        });
        sendGTMEvent(AnalyticsEventType.Event, AnalyticsCategories.gdprCookiesInfo, AnalyticsLabels.button, AnalyticsActions.acceptAllGdprCookiesClick);
      }, 1000);
    };
    $[3] = setAnalyticsCookie;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const acceptAll = t1;
  let t2;
  if ($[5] !== analyticsCookie?.isMarketingOn || $[6] !== analyticsCookie?.isSentryOn || $[7] !== analyticsCookie?.isStatisticsOn || $[8] !== router) {
    t2 = function acceptSelected() {
      if (analyticsCookie?.isStatisticsOn && analyticsCookie?.isMarketingOn && analyticsCookie?.isSentryOn) {
        sendGTMEvent(AnalyticsEventType.Event, AnalyticsCategories.gdprCookiesInfo, AnalyticsLabels.button, AnalyticsActions.acceptAllGdprCookiesClick);
      } else {
        sendGTMEvent(AnalyticsEventType.Event, AnalyticsCategories.gdprCookiesSettings, AnalyticsLabels.button, AnalyticsActions.acceptGdprCookiesClick);
        if (!analyticsCookie?.isStatisticsOn || !analyticsCookie?.isMarketingOn) {
          router.refresh();
        }
      }
    };
    $[5] = analyticsCookie?.isMarketingOn;
    $[6] = analyticsCookie?.isSentryOn;
    $[7] = analyticsCookie?.isStatisticsOn;
    $[8] = router;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const acceptSelected = t2;
  let t3;
  if ($[10] !== acceptAll || $[11] !== acceptSelected || $[12] !== rejectAll || $[13] !== showSettingsPanel) {
    t3 = showSettingsPanel ? <GDPRCookiesSettings setShowSettingsPanel={setShowSettingsPanel} acceptAllCookies={acceptAll} acceptCurrentCookies={acceptSelected} /> : <GDPRInfoPanel setShowSettingsPanel={setShowSettingsPanel} rejectAll={rejectAll} acceptAll={acceptAll} />;
    $[10] = acceptAll;
    $[11] = acceptSelected;
    $[12] = rejectAll;
    $[13] = showSettingsPanel;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}